import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Notices from 'flarum/forum/components/Notices';
import Alert from 'flarum/common/components/Alert';
export default function addTranslationQuotaNotice() {
  extend(Notices.prototype, 'items', function (items) {
    if (!app.session.user?.isAdmin()) return;
    if (!app.forum.attribute('translationQuotaExhausted')) return;
    items.add('glowingblue-translate-quota', m(Alert, {
      type: "error",
      dismissible: false,
      className: "Alert--translationQuota",
      containerClassName: "container",
      controls: [m("a", {
        className: "Button Button--link",
        target: "_blank",
        href: app.forum.attribute('adminUrl') + '#/extension/glowingblue-translate'
      }, app.translator.trans('glowingblue-translate.forum.notices.quota_exhausted_link'))]
    }, app.translator.trans('glowingblue-translate.forum.notices.quota_exhausted')), 70);
  });
}
flarum.reg.add('glowingblue-translate', 'forum/extenders/addTranslationQuotaNotice', addTranslationQuotaNotice);